import UserRoles from '@/common/enums/user-roles.enum';
import { without } from '@/globals';
import rootState from '@/store/state';

import * as types from './mutation-types';

const mutations = {
  [types.UPDATE_USERORGANIZATIONS_LIST](state, userOrganizations) {
    state.userOrganizations = userOrganizations;
  },
  [types.UPDATE_USERORGANIZATION](state, userOrganization) {
    state.userOrganization = userOrganization;
  },
  [types.UPDATE_USERORGANIZATIONS_TOTAL_COUNT](state, count) {
    state.userOrganizationsTotalCount = count;
  },
  [types.UPDATE_ROLES_LIST](state, roles) {
    const isCurateOrganization = rootState?.orgApp?.organization?.isCuratorOrganization;
    state.roles = isCurateOrganization ? roles : roles.filter(({ code }) => code !== UserRoles.CURATOR);
  },
  [types.SAVE_USERORGANIZATIONS](state, userOrganizations) {
    if (!Array.isArray(userOrganizations)) {
      userOrganizations = [userOrganizations];
    }
    userOrganizations.forEach((userOrganization) => {
      if (state.userOrganizations.find((c) => c.id === userOrganization.id) === undefined) {
        state.userOrganizations = [...state.userOrganizations, userOrganization];
      } else {
        state.userOrganizations = [
          ...without(
            state.userOrganizations,
            state.userOrganizations.find((c) => c.id === userOrganization.id),
          ),
          userOrganization,
        ];
      }
    });
  },
  [types.DELETE_USERORGANIZATION](state, userOrganization) {
    state.userOrganizations = without(state.userOrganizations, userOrganization);
  },
  [types.UPDATE_CREATEDBY_USER_LIST](state, userOrganizations) {
    state.createdByUserList = userOrganizations;
  },
};

export default mutations;
